import React from "react"
import DesktopHeaderContainer from "../../../desktopHeaderContainer"
import DesktopSort from "../../../desktopSort"
import ProductsTitle from "../../../productsTitle"
import {SearchBannerChevronContainer} from "./components"
import SearchBannerChevron from "../../../searchBannerChevron"
import FadeInAnimation from "../../../fadeInAnimation"
import {useSearchBannerLoaded} from "../../../../hooks/useSearchBannerLoaded"
import {ChevronWithContext} from "../../../searchBanner/copy/components"

interface StandardProductsHeaderProps {
    url: string
    enableSearchBannerTemplating: boolean
}

const StandardProductsHeader = ({url, enableSearchBannerTemplating}: StandardProductsHeaderProps) => {
    const searchBannerTextLoaded = useSearchBannerLoaded(url)

    return (
        <DesktopHeaderContainer>
            <>
                <ProductsTitle />
                <DesktopSort />
                <SearchBannerChevronContainer data-testid="plp-search-banner-chevron-container">
                    {enableSearchBannerTemplating ? (
                        <ChevronWithContext />
                    ) : (
                        <FadeInAnimation timeout={300} show={searchBannerTextLoaded}>
                            <SearchBannerChevron />
                        </FadeInAnimation>
                    )}
                </SearchBannerChevronContainer>
            </>
        </DesktopHeaderContainer>
    )
}

export default StandardProductsHeader
